<template>
    <div class="app-container">
        <div class="filter-head">
            <el-button type="primary" @click="handleAddTable" v-if="is_grant_integral === 1">新增</el-button>
            <div class="status-filter">
                <div class="filter-item">
                    <el-input v-model="listQuery.user_id" placeholder="用户ID" clearable />
                </div>
                <div class="filter-item">
                    <el-select v-model="listQuery.type" placeholder="类型" clearable>
                        <el-option v-for="item in selectOptions" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="filter-item">
                    <el-button type="primary" @click="handleSearch">搜索</el-button>
                </div>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData" v-loading="listLoading" border fit highlight-current-row height="70vh">
                <el-table-column type="index" label="序号" width="95" align="center" />
                <el-table-column label="头像" min-width="110" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.user_info.head_img"
                            fit="cover"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="user_info.name" label="昵称" min-width="110" align="center" />
                <el-table-column prop="num" label="补偿积分" min-width="110" align="center" />
                <el-table-column prop="type" label="补偿类型" min-width="110" align="center">
                    <template #default="{ row: { type } }">
                        <el-tag type="primary" size="medium">{{ type == 1 ? "活动" : "测评"}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="user_id" label="ID" min-width="110" align="center" />
                <el-table-column prop="remarks" label="补偿备注" min-width="110" align="center" />
                <el-table-column prop="created_at" label="补偿时间" min-width="110" align="center" />
                <el-table-column label="操作" width="150" align="center" fixed="right" v-if="is_grant_integral === 1">
                    <template slot-scope="scope">
                        <el-popconfirm v-if="scope.row.state == 1" title="确定撤销该补偿?"
                            @confirm="handleRevocation(scope.row.id)"
                            @onConfirm="handleRevocation(scope.row.id)"
                            >
                            <el-button slot="reference" size="small" type="danger" :loading="btnLoading">撤销</el-button>
                        </el-popconfirm>
                        <el-tag v-else size="medium" type="info" effect="light" disabled>已撤销</el-tag>
                    </template>
                </el-table-column>
            </el-table>

            <div class="pagination-container">
                <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]"
                    :page-size="listQuery.limit" :total="total" background
                    layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" />
            </div>
        </div>

        <TableActionModal v-if="visible" :show.sync="visible" @success="getList" />
    </div>
</template>

<script>
// 积分管理-积分补偿
import TableActionModal from "./components/TableActionModal.vue"
import { pointCompensation } from "@/api/pointManagement"
import store from '@/store'

export default {
    data: () => ({
        is_grant_integral: '',
        selectVal: null,
        selectOptions: [
            {
                value: 2,
                label: '测评'
            },
            {
                value: 1,
                label: '活动'
            }
        ],
        tableData: [],
        total: null,
        listQuery: {
            page: 1,
            limit: 10,
            type: "",
            user_id: "",
        },
        modalType: 'add',
        visible: false,
        listLoading: false,
        btnLoading: false
    }),
    components: {
        TableActionModal
    },
    methods: {
        async getList() {
            this.listLoading = true
            this.tableData = []
            const { data } = await pointCompensation.list(this.listQuery)
            this.tableData = data.data;
            this.total = data.total;
            this.listLoading = false;
        },
        // 分页操作
        handleSizeChange(limit) {
            this.listQuery.limit = limit
            this.getList()
        },
        handleCurrentChange(page) {
            this.listQuery.page = page
            this.getList()
        },
        // 添加数据
        handleAddTable() {
            this.visible = true
        },
        async handleRevocation(id) {
            console.log('触发了')
            try {
                this.btnLoading = true
                await pointCompensation.revoke(id)
                this.$message({
                    message: '撤销成功!',
                    type: 'success'
                });
                this.getList()
            } catch {
                this.$message.error('出错了!');
            } finally {
                this.btnLoading = false
            }
        },
        handleSearch() {
            this.listQuery.page = 1
            this.getList()
        }
    },
    created() { 
        this.getList() 
        this.is_grant_integral = store.getters.is_grant_integral
    }
}
</script>

<style lang="scss" scoped>
.filter-head {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .status-filter {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 -5px;

        .filter-item {
            margin: 0 5px;
        }
    }
}

.table {
    margin-top: 10px;
}
</style>